import { render, staticRenderFns } from "./DialogInstagramCampaignEdit.vue?vue&type=template&id=40c36936&scoped=true"
import script from "./DialogInstagramCampaignEdit.vue?vue&type=script&setup=true&lang=ts"
export * from "./DialogInstagramCampaignEdit.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DialogInstagramCampaignEdit.vue?vue&type=style&index=0&id=40c36936&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c36936",
  null
  
)

export default component.exports